import React, { Component } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import { withNamespaces } from "react-i18next";
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";

// import MobileContactUs from "./MobileContactUs";

class MobileContactUsHome extends Component {

  render() {
    const { t, img, icon, ContactUsType } = this.props;

    return (
      <Auxiliary>
            <MobileSubHeader
                className="bg-white"
                returnPage="/"
                header={t("contact-us.contact-us")}
                subPage={true}
            />
            <section
                className="contact-us-section"
            >
                <div className="m-container">
                    <div className="section-header text-center">
                        <h2 className="no-banner">{t("contact-us.contact-us")}</h2>
                        <p>
                            {t("contact-us.contact-us-details")} {" "}
                                <a href="" target="_blank">
                                {t("info-centre.faq")} {""}
                                </a>
                            {t("contact-us.contact-us-details-2")} {t("contact-us.contact-us-details-3")}
                        </p>
                    </div>
                    {/* <LazyLoadImage
                        className="contact-us-img"
                        src={img["customer-img.webp"]}
                        alt="customer-img"
                        effect="blur"
                    /> */}
                    <div className="d-flex justify-content-center my-2">
                        <img src={img["customer-img.webp"]} alt="customer-img"/>
                    </div>
                    <div className="contact-us-container">
                        <div className="row g-4">
                            <ContactUsType
                                onClick={window['liveChatButton']}
                                icon={icon}
                                img={img}
                                iconImg="live-chat.svg"
                                iconHover="live-chat-blue.svg"
                                title={t("contact-us.live-chat")}
                                content={
                                <p>
                                    {t("contact-us.live-chat-details")}
                                </p>
                                }
                            />
                            <ContactUsType
                                // link={`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_MERCHANT_WHATSAPP.replace(/[+ ]/g, '')}&text=Welcome%20to%20${process.env.REACT_APP_WEBSITE_TITLE}%20%EF%BC%81`}
                                icon={icon}
                                img={img}
                                iconImg="whatsapp.svg"
                                iconHover="whatsapp-blue.svg"
                                title={t("contact-us.whatsapp")}
                                content={
                                <p>
                                    {t("contact-us.whatsapp-details")} <br /> 
                                    {/* {process.env.REACT_APP_MERCHANT_WHATSAPP} */}
                                </p>
                                }
                            />
                            <ContactUsType
                                // link={`https://t.me/${process.env.REACT_APP_MERCHANT_TELEGRAM_BOT_SUPPORT}`}
                                icon={icon}
                                img={img}
                                iconImg="telegram.svg"
                                iconHover="telegram-blue.svg"
                                title={t("contact-us.telegram")}
                                content={
                                <p>
                                    {t("contact-us.telegram-details")} <br /> 
                                    {/* {process.env.REACT_APP_MERCHANT_TELEGRAM_BOT} */}
                                    @x33support
                                </p>
                                }
                            />
                            <ContactUsType
                                // link={`mailto:${process.env.REACT_APP_MERCHANT_EMAIL}`}
                                icon={icon}
                                img={img}
                                iconImg="email.svg"
                                iconHover="email-blue.svg"
                                title={t("contact-us.email")}
                                content={
                                <p>
                                    {t("contact-us.email-details")}<br />{" "}
                                    {/* {process.env.REACT_APP_MERCHANT_EMAIL} */}
                                    Support@x33.com
                                </p>
                                }
                            />
                        </div>
                    </div>
                </div>
            </section>
      </Auxiliary>
    );
  }
}

export default (withNamespaces("translation")(MobileContactUsHome));
